import { Badge } from '@mantine/core';
import { useSubscription } from 'urql';
import { NewVoicemailCountSubscription } from './graphql';

export function VoicemailBadge({ organizationId }: { organizationId: string | null }) {
  const [{ data }] = useSubscription({
    query: NewVoicemailCountSubscription,
    variables: { organizationId: organizationId ?? '' },
    pause: !organizationId,
  });

  const count = data?.voicemailsAggregate.aggregate?.count ?? 0;

  if (!count) return null;

  return (
    <Badge size="xs" color="red" variant="filled" circle>
      {count > 99 ? '99+' : count}
    </Badge>
  );
}
